import { forwardRef } from 'react';

import { useEndToEndTestId } from '@perpay-web/hooks/useEndToEndTestId';
import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './CustomInput.scss';

const CustomInput = forwardRef(
    (
        {
            label,
            floatingLabel = true,
            type,
            hidden = false,
            disabled = false,
            value = '',
            name,
            onChange,
            className = '',
            ...rest
        },
        ref,
    ) => {
        const endToEndTestIDParams = useEndToEndTestId();
        return (
            <div className={styles['form-row__field']}>
                <input
                    ref={ref}
                    type={type}
                    name={name}
                    value={value}
                    hidden={hidden}
                    disabled={disabled}
                    onChange={onChange}
                    autoComplete='off'
                    className={getClassName(
                        styles.input,
                        value ? styles['field--populated'] : '',
                        label ? styles['field--labeled'] : '',
                        className,
                    )}
                    data-lpignore='true'
                    {...endToEndTestIDParams}
                    {...rest}
                />
                <span
                    className={getClassName(
                        styles.label,
                        floatingLabel ? styles['label--floating'] : '',
                    )}
                >
                    {label}
                </span>
            </div>
        );
    },
);

CustomInput.displayName = 'CustomInput';

export const CustomInputWithErrors = forwardRef(
    (
        {
            label,
            floatingLabel = true,
            type,
            hidden = false,
            disabled = false,
            onChange,
            name,
            value = '',
            touched = false,
            errors = null,
            ...rest
        },
        ref,
    ) => (
        <div
            className={getClassName(
                styles['form-row'],
                errors && errors[0] && touched ? styles['form-row--error'] : '',
            )}
        >
            <CustomInput
                ref={ref}
                name={name}
                onChange={onChange}
                type={type}
                label={label}
                floatingLabel={floatingLabel}
                hidden={hidden}
                disabled={disabled}
                value={value}
                {...rest}
            />

            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
                className={styles['form-row__help-text']}
                onKeyDown={noop}
                onClick={(e) => {
                    const container = e.currentTarget.parentNode;
                    const input = container.querySelector(`[name="${name}"]`);
                    input.focus();
                }}
            >
                {errors && touched ? errors[0] : ''}
            </div>
        </div>
    ),
);

CustomInputWithErrors.displayName = 'CustomInputWithErrors';
